export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "开标记录",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "openBidRecordName",
            type: "slot",
            slotName: "openBidRecordName",
          },
          {
            label: "公开类型：",
            value: "openType",
            type: "select",
            optionData: [
              { name: "依法公开", value: "0" },
            ],
          },
          {
            label: "标段号：",
            value: "bidSection",
            type: "slot",
            slotName: "bidSection",
          },
          {
            label: "开标地点：",
            value: "bidOpeningAddress",
            type: "input",
            disabled: false,
            maxLength: 500,
            required: true,
            rule: {
              required: true,
              message: "请填写开标地点",
              trigger: "blur"
            }
          },
          {
            label: "开标时间：",
            value: "bidOpeningTime",
            type: "date",
            dateType: "datetime",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            required: true,
            disabled: false,
            TimePickerOptions: {
              disabledDate(date) {
                // 禁用大于今天的日期
                return date.getTime() > Date.now();
              }
            },
            rule: {
              required: true,
              message: "请选择开标时间",
              trigger: "change"
            }
          },
          {
            label: "开标参与人：",
            value: "bidOpeningActor",
            type: "textarea",
            maxLength: 1200,
            required: true,
            width: "100%;",
            rule: {
              required: true,
              message: "请填写开标参与人",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "开标记录内容",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "bidOpeningContent",
            width: "100%;",
            class: "formHtml"
          },
        ]
      },
      {
        title: "第二信封开标记录",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "doubleOpenbidrecordName",
            type: "slot",
            slotName: "doubleOpenbidrecordName",
          },
          {
            label: "公开类型：",
            value: "doubleOpenType",
            type: "select",
            optionData: [
              { name: "依法公开", value: "0" },
            ],
          },
          {
            label: "标段号：",
            value: "bidSection",
            type: "slot",
            slotName: "doubleBidSection",
          },
          {
            label: "开标地点：",
            value: "doubleBidOpeningAddress",
            type: "input",
            disabled: false,
            maxLength: 500,
            required: true,
            rule: {
              required: true,
              message: "请填写开标地点",
              trigger: "blur"
            }
          },
          {
            label: "开标时间：",
            value: "doubleBidOpeningTime",
            type: "date",
            dateType: "datetime",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            required: true,
            disabled: false,
            TimePickerOptions: {
              disabledDate(date) {
                // 禁用大于今天的日期
                return date.getTime() > Date.now();
              }
            },
            rule: {
              required: true,
              message: "请选择开标时间",
              trigger: "change"
            }
          },
          {
            label: "开标参与人：",
            value: "doubleBidOpeningActor",
            type: "textarea",
            maxLength: 1200,
            required: true,
            rule: {
              required: true,
              message: "请填写开标参与人",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "开标记录内容",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "doubleBidOpeningContent",
            width: "100%;",
            class: "noMargin formHtml"
          },
        ]
      },
    ];
  }
}
